import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import { successToast, errorToast } from "../../Utils/toast";
import { sendNotification } from "../../redux/services/NotificationServices/Notification.Services";
import { ActiveUserList } from "../../redux/services/User Services/User.Services";
import { FiChevronDown } from "react-icons/fi";

function Reminder() {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [vendors, setVendors] = useState([]);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  
  const dropdownRef = useRef(null);

  const [formData, setFormData] = useState({
    send_to: "single", 
    vendor_ids: [], 
    title: "",
    message: "",
    type: "general",
    priority: "normal",
  });

  useEffect(() => {
    const fetchVendors = async () => {
      try {
        const res = await ActiveUserList();
        setVendors(res?.data || []);
      } catch (error) {
        console.log("Vendor API error:", error);
      }
    };
    fetchVendors();

    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleVendorToggle = (vendorId) => {
    let newIds = [...formData.vendor_ids];
    
    if (formData.send_to === "single") {
      newIds = [vendorId]; 
      setIsDropdownOpen(false); 
    } else {
      if (newIds.includes(vendorId)) {
        newIds = newIds.filter(id => id !== vendorId);
      } else {
        newIds.push(vendorId);
      }
    }
    setFormData({ ...formData, vendor_ids: newIds });
    setErrors({ ...errors, vendor_ids: null });
  };

  const validate = () => {
    let newErrors = {};
    if (!formData.title) newErrors.title = "Title is required";
    if (!formData.message) newErrors.message = "Message is required";
    if (formData.send_to !== "all" && formData.vendor_ids.length === 0) {
      newErrors.vendor_ids = "Please select at least one vendor";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    try {
      setIsLoading(true);
      let payload = {
        send_to: formData.send_to,
        title: formData.title,
        message: formData.message,
        type: formData.type,
        priority: formData.priority,
      };
      if (formData.send_to !== "all") {
        payload.vendor_ids = formData.vendor_ids;
      }
      
      await sendNotification(payload);
      successToast("Reminder Sent Successfully");
      navigate(-1); 
    } catch (error) {
      console.log(error);
      errorToast(error.response?.data?.message || "Failed to send reminder");
    } finally {
      setIsLoading(false);
    }
  };

  const getSelectedVendorText = () => {
    if (formData.vendor_ids.length === 0) return "Select Vendor(s)";
    if (formData.vendor_ids.length === 1) {
      const v = vendors.find(v => v.id === formData.vendor_ids[0]);
      return v ? `${v.name || v.mobile}` : "1 Vendor Selected";
    }
    return `${formData.vendor_ids.length} Vendors Selected`;
  };

  return (
    <div>
      {/* HEADER */}
      <div className="d-flex align-items-center justify-content-between page-header-breadcrumb">
        <div className="title_member">
          <h4>Add Reminder</h4>
          <nav className="page-breadcrumb">
            <Link to="/">Home</Link>
            <span className="mx-2">/</span>
            <span>Add Reminder</span>
          </nav>
        </div>
        <div className="d-flex flex-wrap gap-2 justify-content-end">
          <button className="add-btn" onClick={() => navigate(-1)}>
            Reminder List
          </button>
        </div>
      </div>

      {/* FORM */}
      <div className="main_page">
        <div className="card">
          <div className="card-body">
            <form onSubmit={handleSubmit}>
              <div className="container">
                <div className="row">
                  
                  <div className="col-md-6 mb-3">
                    <label>Send To <span className="text-danger">*</span></label>
                    <select name="send_to" className="form-control custumform" value={formData.send_to} onChange={(e) => { handleChange(e); setFormData(prev => ({...prev, vendor_ids: []})); }}>
                      <option value="single">Single Vendor</option>
                      <option value="multiple">Multiple Vendors</option>
                      <option value="all">All Vendors</option>
                    </select>
                  </div>

                  {formData.send_to !== "all" && (
                    <div className="col-md-6 mb-3 position-relative" ref={dropdownRef}>
                      <label>Select Vendor(s) <span className="text-danger">*</span></label>
                      
                      <div 
                        className={`form-control custumform d-flex justify-content-between align-items-center ${errors.vendor_ids ? "is-invalid" : ""}`}
                        onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                        style={{ cursor: "pointer", minHeight: "42px" }}
                      >
                        <span>{getSelectedVendorText()}</span>
                        <FiChevronDown />
                      </div>

                      {isDropdownOpen && (
                        <div 
                          className="position-absolute w-100 bg-dark border border-secondary rounded mt-1 shadow-lg" 
                          style={{ zIndex: 1000, maxHeight: "200px", overflowY: "auto" }}
                        >
                          {vendors.length === 0 ? (
                            <div className="p-2 text-white">Loading...</div>
                          ) : (
                            vendors.map(vendor => (
                              <div 
                                key={vendor.id} 
                                className="p-2 d-flex align-items-center text-white"
                                style={{ cursor: "pointer", borderBottom: "1px solid #333" }}
                                onClick={() => handleVendorToggle(vendor.id)}
                              >
                                <input 
                                  type={formData.send_to === "single" ? "radio" : "checkbox"} 
                                  checked={formData.vendor_ids.includes(vendor.id)}
                                  onChange={() => {}} 
                                  className="me-2"
                                />
                                {vendor.name ? `${vendor.name} (${vendor.mobile})` : vendor.mobile}
                              </div>
                            ))
                          )}
                        </div>
                      )}
                      {errors.vendor_ids && <small className="text-danger">{errors.vendor_ids}</small>}
                    </div>
                  )}

                  <div className="col-md-6 mb-3">
                    <label>Title <span className="text-danger">*</span></label>
                    <input
                      type="text"
                      name="title"
                      className={`form-control custumform ${errors.title ? "is-invalid" : ""}`}
                      placeholder="Enter Reminder Title"
                      value={formData.title}
                      onChange={handleChange}
                    />
                    {errors.title && <small className="text-danger">{errors.title}</small>}
                  </div>

                  <div className="col-md-6 mb-3">
                    <label>Priority</label>
                    <select name="priority" className="form-control custumform" value={formData.priority} onChange={handleChange}>
                      <option value="normal">Normal</option>
                      <option value="high">High</option>
                      <option value="urgent">Urgent</option>
                    </select>
                  </div>

                  <div className="col-md-12 mb-3">
                    <label>Message <span className="text-danger">*</span></label>
                    <textarea
                      name="message"
                      className={`form-control custumform ${errors.message ? "is-invalid" : ""}`}
                      rows="4"
                      placeholder="Enter Message"
                      value={formData.message}
                      onChange={handleChange}
                    ></textarea>
                    {errors.message && <small className="text-danger">{errors.message}</small>}
                  </div>

                  <div className="col-md-12">
                    <div className="d-flex justify-content-end">
                      <div className="button_submit">
                        <button type="submit" className="total_btn" disabled={isLoading}>
                          {isLoading ? "Loading..." : "Send Reminder"}
                        </button>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Reminder;